<template>
    <div>
        <v-form ref="formDatos" lazy-validation>
            <v-dialog v-model="estadoComp" persistent scrollable max-width="75%">
                <v-card>

                    <v-card-title class="btn_otro">
                        <v-row class="d-flex justify-space-between py-3">
                            {{ formTitle }}
                            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon
                                    dark>fa-times</v-icon></v-btn>
                        </v-row>
                    </v-card-title>

                    <v-card-text>
                        <v-row class="pt-0" v-if="componenteEvento.agregar_submodulo">
                            <v-col class="d-flex flex-row-reverse pt-8">
                                <v-btn class="btn_block_style2" dark @click="addItem()"> <v-icon left>fa-plus</v-icon> Crear
                                    Plantilla</v-btn>
                            </v-col>
                        </v-row>

                        <v-col class="d-flex justify-end pt-0">
                            <v-col class="pt-0" cols="4">
                                <v-text-field label="Buscar" v-model="search" append-icon="fa-search" single-line
                                    hide-details></v-text-field>
                            </v-col>
                        </v-col>

                        <v-row>
                            <v-col cols="12">
                                <v-data-table :headers="headers" :items="data" :search="search"
                                    :sort-by="['nombre_template']" :sort-desc="[false]" class="elevation-1 black--text"
                                    fixed-header>


                                    <template v-slot:[`item.action_fec_us_ing`]="{ item }">
                                        {{ item.fec_us_ing | filtroFecha }}
                                    </template>

                                    <template v-slot:[`item.action_fec_us_mod`]="{ item }">
                                        {{ item.fec_us_mod | filtroFecha }}
                                    </template>

                                    <template v-slot:[`item.estado_template`]="{ item }">
                                        <v-chip v-if="item.estado_template === true" small class="color_activo">
                                            Activo
                                        </v-chip>

                                        <v-chip v-if="item.estado_template === false" small class="color_inactivo">
                                            Inactivo
                                        </v-chip>
                                    </template>

                                    <template v-slot:[`item.action_editar`]="{ item }">
                                        <v-tooltip bottom color="#1b1b1b">
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-if="componenteEvento.editar_submodulo" v-on="on"
                                                    class="btn_editar px-0 mx-0" fab x-small @click="editItem(item)">
                                                    <v-icon>fa-pencil-alt</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>EDITAR PLANTILLA</span>
                                        </v-tooltip>
                                    </template>

                                    <template v-slot:[`item.action_borrar`]="{ item }">
                                        <v-tooltip bottom color="#1b1b1b">
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-if="componenteEvento.borrar_submodulo" v-on="on"
                                                    class="btn_eliminar px-0 mx-0" fab x-small
                                                    @click="deleteUsuario(item.id)">
                                                    <v-icon>fa-trash-alt</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>BORRAR PLANTILLA</span>
                                        </v-tooltip>
                                    </template>

                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>


                </v-card>
            </v-dialog>
        </v-form>

        <!-- fin modal del Colegio -->

        <component :is="compName" :estadoModal="estadoModalConfig" :parametros="parametroConfig" @close="closeModal">
        </component>

    </div>
</template>

<script>


import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';

import TemplateFormComp from './components/TemplateFormComp'
export default {
    name: 'templateGestor',

    props: ['estadoComp', 'parametros', 'evento'],

    components: {
        TemplateFormComp
    },
    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        paramComponente: { "id_modulo": 4, 'id_submodulo': 22 }, //sud_modulo y modulo
        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////
        search: '',
        data: [],

        headers: [
            /* { text: 'INDEX', align: 'left', value: 'index', class:'secondary'},
            { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
            // { text: 'ID', value: 'id' , class:'secondary black--text'},
            { text: 'NOMBRE DE LA PLANTILLA', value: 'nombre_template', class: 'secondary black--text' },
            { text: 'FECHA DE CREACIÓN', value: 'action_fec_us_ing', class: 'secondary black--text' },
            { text: 'FECHA DE EDICIÓN', value: 'action_fec_us_mod', class: 'secondary black--text' },
            { text: 'ESTADO', value: 'estado_template', align: 'center', class: 'secondary black--text' },
            { text: 'EDITAR', value: 'action_editar', sortable: false, align: 'center', class: 'secondary black--text' },
            // { text: 'BORRAR', value: 'action_borrar', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'1'}

        ],

        formTitle: 'Visualizar plantillas',

        compName: null,
        estadoModalConfig: false,
        parametroConfig: [],


    }),


    //computadas
    computed: {
        ...mapGetters('login', ['componenteEvento']),


    },


    mounted() {
        this.loadMain()
    },


    created() {
        this.actualizarParamentro()
    },


    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
        // -- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),
        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },


        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////

        //-- cargar Parametros de inicio del componente --
        async loadMain() {
            // this.getTemplate()
        },


        //-------mostrar registros------------
        async getTemplate() {

            try {
                let response = await axios.post(`/manager/contenido/getTemplateDiap/`, { filtro: { tipo: 1 } })
                this.data = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },


        ///////////////////////////////////////////////////
        //-- Componente de  Configuracion de colegio  -----
        ///////////////////////////////////////////////////

        addItem() {
            //this.setEnviarMens({tipo:"W", mensaje: `Agregar Formulario`, tiempo:null})
            this.parametroConfig = { evento: "agregar", id_nivel: this.parametros.id_nivel_grado, id_pais: this.parametros.id_pais }
            this.compName = "TemplateFormComp"
            this.estadoModalConfig = true
        },

        editItem(item) {
            // this.setEnviarMens({tipo:"W", mensaje: `Editar Formulario`, tiempo:null})
            this.parametroConfig = { evento: "editar", item, id_nivel: item.id_nivel, id_pais: this.parametros.id_pais }
            this.compName = "TemplateFormComp"
            this.estadoModalConfig = true
        },


        /*******cerrar modal y blanquear arreglos */
        closeModal() {

            this.$emit('reloadComp', 'template')
            this.estadoModalConfig = false;
            this.loadMain()

        },

    },

}
</script>

<style scoped></style>